import { AssignmentRelationType } from "@kolibrisoftware/customerportal-api";
import { ContentSection } from "@kolibrisoftware/customerportal-ui";
import { useTranslation } from "@kolibrisoftware/hooks-util";
import { useTheme } from "injectors/theme";
import { FC, useMemo } from "react";
import { HeaderSection } from "shared/ui/header-section/header-section";
import { useSelector } from "store/helpers";
import ObjectCarousel from "../components/object-carousel";
import ObjectDescriptionSection from "../components/object-description-section";
import ObjectDetailsSection from "../components/object-details-section";
import ObjectTabs from "../components/object-tabs";
import { useStyles } from "./styles";

type Props = {};

const ObjectPreview: FC<Props> = props => {
  const theme = useTheme();
  const styles = useStyles({ theme });
  const t = useTranslation();
  const userLinkType = useSelector(state => state.dossier.userLinkType);

  const translations = useMemo(
    () => ({
      headerTitle: t("objectPreview.headerTitle"),
      headerDescription: t("objectPreview.headerDescription"),
      peculiaritiesText: t("objectPreview.peculiaritiesText.title"),
      advertisementText: t("objectPreview.description.title"),
      firstFloorText: t("objectPreview.firstFloorText.title"),
      groundFloorText: t("objectPreview.groundFloorText.title"),
      secondFloorText: t("objectPreview.secondFloorText.title"),
      otherFloorsText: t("objectPreview.otherFloorsText.title"),
      balconyText: t("objectPreview.balconyText.title"),
      gardensText: t("objectPreview.gardensText.title"),
    }),
    [t]
  );

  const {
    advertisementText,
    peculiaritiesText,
    firstFloorText,
    balconyText,
    gardensText,
    groundFloorText,
    otherFloorsText,
    secondFloorText,
  } = useSelector(state => state.objectPreview.assignmentPreview);

  const sortedTexts = useMemo(
    () => ({
      advertisementText,
      groundFloorText,
      firstFloorText,
      secondFloorText,
      otherFloorsText,
      balconyText,
      gardensText,
      peculiaritiesText,
    }),
    [
      advertisementText,
      groundFloorText,
      firstFloorText,
      secondFloorText,
      otherFloorsText,
      balconyText,
      gardensText,
      peculiaritiesText,
    ]
  );

  return (
    <div className={styles.objectPreviewScreen}>
      {userLinkType === AssignmentRelationType.Vendor && (
        <HeaderSection
          title={translations.headerTitle}
          description={translations.headerDescription}
        />
      )}

      <ContentSection style={{ padding: 0 }} data-cy="CarouselContentSection">
        <ObjectCarousel />
        <ObjectTabs />
      </ContentSection>

      {Object.entries(sortedTexts).map(([key, value]) => {
        return (
          <ObjectDescriptionSection
            key={key}
            title={translations[key as keyof typeof translations]}
            content={value}
          />
        );
      })}

      <ObjectDetailsSection />
    </div>
  );
};

export { ObjectPreview };
